import React from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

const TermsOfService = ({ t }) => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <Link to="/" className="back-link">← {t.terms.backToHome}</Link>
          <h1>{t.terms.title}</h1>
          <p className="legal-last-updated">{t.terms.lastUpdated}</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>{t.terms.acceptanceOfTerms.title}</h2>
            <p>{t.terms.acceptanceOfTerms.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.terms.servicesDescription.title}</h2>
            <p>{t.terms.servicesDescription.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.terms.userObligations.title}</h2>
            <p>{t.terms.userObligations.intro}</p>
            <ul>
              {t.terms.userObligations.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t.terms.intellectualProperty.title}</h2>
            <p>{t.terms.intellectualProperty.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.terms.limitationOfLiability.title}</h2>
            <p>{t.terms.limitationOfLiability.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.terms.termination.title}</h2>
            <p>{t.terms.termination.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.terms.governingLaw.title}</h2>
            <p>{t.terms.governingLaw.content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.terms.contactInformation.title}</h2>
            <p>{t.terms.contactInformation.content}</p>
            <div className="legal-contact-details">
              <p><strong>{t.terms.contactInformation.email}:</strong> info@armarayan.com</p>
              <p><strong>{t.terms.contactInformation.address}:</strong> {t.contact.addressValue}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;

